module.exports = __webpack_public_path__ + "static/media/Mihail.652838f6.jpg";